import { AxiosResponse } from 'axios';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { Device } from '../types/Device';
import { DeviceImportSummary } from '../types/device-import-summary';
import { InventoryRecord } from '../types/InventoryRecord';
import { PaginatedResult } from '../types/PaginatedResult';

import { httpGet, uploadFiles } from './api.service';

export const getImportSummaries = async (request: PaginatedRequest): Promise<PaginatedResult<InventoryRecord>> => {
  return await httpGet<PaginatedResult<InventoryRecord>>(`api/device/import`, request);
};

export const getImportedDevices = (id: string) => {
  return async (params: any): Promise<PaginatedResult<Device>> => {
    const response = await httpGet<PaginatedResult<Device>>(`api/device/import/${id}`, params);
    return response;
  };
};

export const uploadOnAssetDevices = async (file: File, onUploadProgress: (progressEvent: ProgressEvent) => void): Promise<DeviceImportSummary> => {
  const response: AxiosResponse = await uploadFiles(`api/device/import/onasset`, { fileProcess: file }, onUploadProgress);

  if (response && response.status === 200) {
    return response.data;
  } else throw Error('Failed to upload file');
};
